export default class DefaultData {
  static PRODUCT_PAGE_SETTINGS = {
    checkout_url: "",
    color_picker_style: "square",
    variant1_style: "btn_horizontal",
    variant2_style: "btn_horizontal",
    variant3_style: "btn_horizontal",
    product_page_count: 18,
    column_no: 3,
    cart_icon_route: "modal",
    cart_drawer_checkout: true,
    cart_drawer_checkout_style: "primary",
    cart_drawer_checkout_position: 0,
    cart_drawer_view_cart: false,
    cart_drawer_view_cart_style: "primary",
    cart_drawer_view_cart_position: 1,
    cart_drawer_continue_shopping: true,
    cart_drawer_continue_shopping_style: "secondary",
    cart_drawer_continue_shopping_position: 2,
    cart_page_product: null,
    meta_field_type: "tabs",
    collapsible_list_open_icon: "fa-plus fas",
    collapsible_list_close_icon: "fa-minus fas",
    collapsible_list_toggle: true,
    column_width: "standard",
    slider_position: "below",
    image_shape: "rounded",
    img_tile_position: "right",
    img_only_aspect_ratio: "default",
    display_variant_tile_price: false,
    autoplay_carousel_toggle: false,
    showResetLayoutModal: false,
    product_page_html: "",
    product_page_html_lazy_load: false,
    cart_page_html: "",
    cart_page_html_lazy_load: false,
  }

  static PRODUCT_PAGE_LAYOUT = [
    {key: "product_image", label: "Images", position: "left"},
    {key: "description", label: "Description", position: "left"},
    {key: "metafields", label: "Metafields", position: "left"},
    {key: "title", label: "Title", position: "right"},
    {key: "price", label: "Price", position: "right"},
    {key: "variants", label: "Variants", position: "right"},
    {key: "custom_message_options", label: "Custom Message Options", position: "right"},
    {key: "subscribe_save", label: "Subscribe & Save", position: "right"},
    {key: "quantity_cart", label: "Quantity & Buttons", position: "right"},
    {key: "share_product", label: "Share Product", position: "right"},
    ...Array.from({length: 9}, (_, i) => ({
      key: `storefront_detail_${i + 1}`,
      label: `Detail ${i + 1}`,
      position: "row"
    }))
  ]
}
